import React, { useState, useEffect } from "react";
import clsx from "clsx";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    InputAdornment,
    IconButton,
    FormControl,
    InputLabel,
    Input,
    FormControlLabel
} from "@mui/material";
import BackButton from "../../components/BackButton/BackButton";
import SearchIcon from "@mui/icons-material/Search";
import { Visibility, VisibilityOff } from "@mui/icons-material";
// import {
//     MuiPickersUtilsProvider,
//     DatePicker
// } from "@mui/material/pickers";
// import Tooltip from "@mui/material/Tooltip";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch, AiOutlineUser } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import SOLogout from "../../components/Logout/SOLogout";
import FileBase64 from "../../components/Upload/UploadFile";
import Util from "../../validation/index";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

import { dealerAddUpdateDivisonList } from '../../redux/actions/dealerAddUpdateDivisionListAction';
import { dealerAddUpdateDistrictList } from "../../redux/actions/dealerAddUpdateDistrictListAction";
import { dealerAddUpdateThanaList } from '../../redux/actions/dealerAddUpdateThanaListAction';
import { dealerAddUpdateUnionList } from '../../redux/actions/dealerAddUpdateUnionListAction';
import { dealerMultipleMappingList } from "../../redux/actions/dealerMultipleMappingListAction";
import { dealerDsrList } from "../../redux/actions/dealerDsrListAction";
import { dealerCheckList } from '../../redux/actions/dealerCheckListAction'

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650
    },
    margin: {
        margin: theme.spacing(1)
    },
    root: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        width: "25ch"
    }
}));

const DealerMultipleDsrMapping = () => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [editOpenMapDsr, setEditOpenMapDsr] = useState(false)

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const partnerloginUser = useSelector(({ login }) => login);
    // var authToken = partnerloginUser.data.AuthToken;
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;

    const [getDsrMultiplMappingListStatus, setGetDsrMultiplMappingListStatus] = useState(false);
    const [getDsrMultiplMappingListStatusArray, setGetDsrMultiplMappingListStatusArray] = useState([]);

    const [setAddUpdateDivisionListStatus, setSetAddUpdateDivisionListStatus] = useState(false);
    const [setAddUpdateDivisionListArray, setSetAddUpdateDivisionListArray] = useState([]);

    const [setAddUpdateDistrictListStatus, setSetAddUpdateDistrictListStatus] = useState(false);
    const [setAddUpdateDistrictListArray, setSetAddUpdateDistrictListArray] = useState([]);


    const [setAddUpdateThanaListStatus, setSetAddUpdateThanaListStatus] = useState(false);
    const [setAddUpdateThanaListArray, setSetAddUpdateThanaListArray] = useState([]);

    const [setAddUpdateUnionListStatus, setSetAddUpdateUnionListStatus] = useState(false);
    const [setAddUpdateUnionListArray, setSetAddUpdateUnionListArray] = useState([]);

    const [setDsrListStatus, setSetDsrListStatus] = useState(false);
    const [setDsrListArray, setSetDsrListArray] = useState([]);


    const [mapDsrStatus, setMapDsrStatus] =
        useState(false);
    const [mapDsrStatusResArray, setMapDsrStatusResArray] =
        useState("");
    const [checkListNotification, setCheckListNotification] = useState(false)

    const [getEmailOtp, setGetEmailOtp] = useState("");

    const [reqArr, setReqArr] = useState([])
    const [editDivision, setEditDivision] = useState("");
    const [editDistrict, setEditDistrict] = useState("");
    const [editThana, setEditThana] = useState("");
    const [editUnion, setEditUnion] = useState("");

    const [getCustId, setGetCustId] = useState("");
    const [getDsrId, setGetDsrId] = useState("");
    const [getName, setGetName] = useState("");
    const [getContact, setGetContact] = useState("");

    // const [mapUser, setMapUser] = useState({
    //     getCustId: "",
    //     getDsrId: "",
    //     getName: "",
    //     getContact: ""
    // });
    // const {
    //     getCustId,
    //     getDsrId,
    //     getName,
    //     getContact
    // } = mapUser



    const [user, setUser] = useState({
        getRole: "",
        division: "",
        district: "",
        thana: "",
        union: ""
    });
    const {
        getRole,
        division,
        district,
        thana,
        union
    } = user

    const onInputChangeMod = ({ target: { name, value } }, type) => {

        const obj = {
            ...user,

        };
        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else {
            // obj[name] = value.trim()
            obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
        }
        setUser(obj);
    }

    const setDivisionList = useSelector(
        ({ dealerAddUpdateDivisionLists }) => dealerAddUpdateDivisionLists
    )
    const setDistrictList = useSelector(
        ({ dealerAddUpdateDistrictLists }) => dealerAddUpdateDistrictLists
    )

    const setThanaList = useSelector(
        ({ dealerAddUpdateThanaLists }) => dealerAddUpdateThanaLists
    )

    const setUnionList = useSelector(
        ({ dealerAddUpdateUnionLists }) => dealerAddUpdateUnionLists
    )
    const getDealerMultipleMappingListRes = useSelector(
        ({ dealerMultipleMappingLists }) => dealerMultipleMappingLists
    )

    const setDsrList = useSelector(({ dealerDsrList }) => dealerDsrList);

    const getCheckListRes = useSelector(({ dealerCheckLists }) => dealerCheckLists)

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChange = ({ target: { name, value } }) => {
        if (name === "getEmailOtp") {
            setGetEmailOtp(value);
        }
        if (name === "EditDivision") {
            // setCurrency(value);
            // setEditCurrency(value);
            setEditDivision(value == "Select Division" ? "" : value);
        }
        if (name === "EditDistrict") {
            // setCurrency(value);
            // setEditCurrency(value);
            setEditDistrict(value == "Select District" ? "" : value);
        }
        if (name === "EditThana") {

            setEditThana(value == "Select Thana" ? "" : value);
        }
        if (name === "EditUnion") {

            setEditUnion(value == "Select Union" ? "" : value);
        }
    };

    const handleClose = () => {
        setEditOpenMapDsr(false)
        setGetEmailOtp("")
    }
    const handleNoticationClose = () => {

        setCheckListNotification(false)


    };
    const setAddUpdateDivisionListReq = () => {
        setSetAddUpdateDivisionListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",


            }
        }
        dispatch(dealerAddUpdateDivisonList(req, authToken))
    }
    const AddUpdateDivisionListFunc = () => {
        if (setAddUpdateDivisionListStatus) {
            if (setDivisionList.data.status == "success") {
                setSetAddUpdateDivisionListArray(setDivisionList.data.list);
            }
            if (setDivisionList.data.status == "failed") {
                setSetAddUpdateDivisionListArray(setDivisionList.data);
            }
        }
    };
    useEffect(() => {
        AddUpdateDivisionListFunc();
    }, [setDivisionList.data.status]);
    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {

            setAddUpdateDivisionListReq()

        }
    }, [regenerateTokenRes.data.status])

    const setAddUpdateDistrictListReq = () => {
        setSetAddUpdateDistrictListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",
                district: editDivision

            }
        }
        dispatch(dealerAddUpdateDistrictList(req, authToken))
    }

    const AddUpdateDistrictListFunc = () => {
        if (setAddUpdateDistrictListStatus) {
            if (setDistrictList.data.status == "success") {
                setSetAddUpdateDistrictListArray(setDistrictList.data.list);
            }
            if (setDistrictList.data.status == "failed") {
                setSetAddUpdateDistrictListArray(setDistrictList.data);
            }
        }
    };

    useEffect(() => {
        if (editDivision) {
            setAddUpdateDistrictListReq()
        }
    }, [editDivision])
    useEffect(() => {
        AddUpdateDistrictListFunc()
    }, [setDistrictList.data.status])

    // useEffect(() => {
    //     if (division) {
    //         setAddUpdateDistrictListReq()
    //     }
    // }, [division])

    const setAddUpdateThanaListReq = () => {
        setSetAddUpdateThanaListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",
                district: editDistrict

            }
        }
        dispatch(dealerAddUpdateThanaList(req, authToken))
    }

    const AddUpdateThanaListFunc = () => {
        if (setAddUpdateThanaListStatus) {
            if (setThanaList.data.status == "success") {
                setSetAddUpdateThanaListArray(setThanaList.data.list);
            }
            if (setThanaList.data.status == "failed") {
                setSetAddUpdateThanaListArray(setThanaList.data);
            }
        }
    };
    useEffect(() => {
        if (editDistrict) {
            setAddUpdateThanaListReq()
        }
    }, [editDistrict])

    useEffect(() => {
        AddUpdateThanaListFunc();
    }, [setThanaList.data.status]);

    // useEffect(() => {
    //     if (division) {
    //         setAddUpdateThanaListReq()
    //     }
    // }, [division])


    const setAddUpdateUnionListReq = () => {
        setSetAddUpdateUnionListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",
                district: editDistrict,
                thana: editThana

            }
        }
        dispatch(dealerAddUpdateUnionList(req, authToken))
    }

    const AddUpdateUnionListFunc = () => {
        if (setAddUpdateUnionListStatus) {
            if (setUnionList.data.status == "success") {
                setSetAddUpdateUnionListArray(setUnionList.data.list);
            }
            if (setUnionList.data.status == "failed") {
                setSetAddUpdateUnionListArray(setUnionList.data);
            }
        }
    };
    useEffect(() => {
        setAddUpdateUnionListReq()
    }, [editDivision, editThana])

    useEffect(() => {
        AddUpdateUnionListFunc();
    }, [setUnionList.data.status]);

    useEffect(() => {

        // setEditDivision('');
        setEditDistrict('');
        setEditThana('');
        setEditUnion('')

    }, [editDivision])


    // const setAddUpdateDivisionListReq = () => {
    //     const req = {
    //         actionCustomerMasterRequestVO: {
    //             dealerId: regenerateTokenRes.data.partnerId || "",


    //         }
    //     }
    //     dispatch(dealerAddUpdateDivisonList(req, authToken))
    // }
    // useEffect(() => {
    //     if (regenerateTokenRes.data.status == "success") {

    //         setAddUpdateDivisionListReq()

    //     }
    // }, [regenerateTokenRes.data.status])

    // const setAddUpdateDistrictListReq = () => {
    //     const req = {
    //         actionCustomerMasterRequestVO: {
    //             dealerId: regenerateTokenRes.data.partnerId || "",
    //             district: division

    //         }
    //     }
    //     dispatch(dealerAddUpdateDistrictList(req, authToken))
    // }

    // useEffect(() => {
    //     if (division) {
    //         setAddUpdateDistrictListReq()
    //     }
    // }, [division])

    // const setAddUpdateThanaListReq = () => {
    //     const req = {
    //         actionCustomerMasterRequestVO: {
    //             dealerId: regenerateTokenRes.data.partnerId || "",
    //             district: division

    //         }
    //     }
    //     dispatch(dealerAddUpdateThanaList(req, authToken))
    // }

    // useEffect(() => {
    //     if (division) {
    //         setAddUpdateThanaListReq()
    //     }
    // }, [division])


    // const setAddUpdateUnionListReq = () => {
    //     const req = {
    //         actionCustomerMasterRequestVO: {
    //             dealerId: regenerateTokenRes.data.partnerId || "",
    //             district: division,
    //             thana: thana

    //         }
    //     }
    //     dispatch(dealerAddUpdateUnionList(req, authToken))
    // }


    // useEffect(() => {
    //     if (division && thana) {
    //         setAddUpdateUnionListReq()
    //     }
    // }, [division, thana])

    const getMultipleMappingListReq = () => {
        setIsLoading(true);
        setGetDsrMultiplMappingListStatus(true)
        const Request = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",
                role: getRole,
                thana: editThana,
                division: editDivision === "Select Divison" ? "" : editDivision,
                district: editDistrict,
                union: editUnion
            }
        }
        dispatch(dealerMultipleMappingList(Request, authToken))
    }

    const getMultipleMappingListFunc = () => {
        if (getDsrMultiplMappingListStatus) {
            if (getDealerMultipleMappingListRes.data.status == "success") {
                setGetDsrMultiplMappingListStatusArray([].concat(getDealerMultipleMappingListRes.data.dsrList));
                setIsLoading(false);


            }
            if (getDealerMultipleMappingListRes.data.status == "failed") {
                setIsLoading(false);

                setGetDsrMultiplMappingListStatusArray(getDealerMultipleMappingListRes.data);
                if (
                    getDealerMultipleMappingListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getDealerMultipleMappingListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getDealerMultipleMappingListRes.data.status == "Failed") {
                setGetDsrMultiplMappingListStatusArray(getDealerMultipleMappingListRes.data);
                if (
                    getDealerMultipleMappingListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getDealerMultipleMappingListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getDealerMultipleMappingListRes.data.status == "NOT FOUND") {
                setGetDsrMultiplMappingListStatusArray([]);
                // setShow(true);
            }
        }
    }
    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {

            getMultipleMappingListReq();
        }
    }, [regenerateTokenRes.data.status]);

    useEffect(() => {
        getMultipleMappingListFunc();
    }, [getDealerMultipleMappingListRes.data.status]);

    const setDsrListReq = () => {
        setSetDsrListStatus(true);
        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || ""


            }
        };
        dispatch(dealerDsrList(req, authToken));
    };
    const DsrListFunc = () => {
        if (setDsrListStatus) {
            if (setDsrList.data.status == "success") {
                setSetDsrListArray([].concat(setDsrList.data.actionList));
            }
            if (setDsrList.data.status == "failed") {
                setSetDsrListArray(setDsrList.data);
                if (
                    setDsrList.data.description == "session out" ||
                    setDsrList.data.description == "Authorization failed"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };
    useEffect(() => {
        DsrListFunc();
    }, [setDsrList.data.status]);

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            setDsrListReq();
        }
    }, [regenerateTokenRes.data.status]);

    const MapDsr = () => {
        // setGetCustId(customerId)
        setEditOpenMapDsr(true)
    }

    const [blockIDS, setBlockIDS] = useState({
        blockId: []
    });

    const handleChangeCheck = (id, e) => {
        const { value, checked } = e.target;
        const { blockId } = blockIDS;
        if (checked) {
            setBlockIDS({
                blockId: [...blockId, id]
            });
        } else {
            setBlockIDS({
                blockId: blockId.filter((e) => e !== id)
            });
        }
    };

    useEffect(() => {
        if (getEmailOtp && blockIDS.blockId) {
            setReqArr(blockIDS.blockId.map((x) => (
                {
                    dealerId: regenerateTokenRes.data.partnerId,
                    id: "",
                    customerId: x,
                    dsrId: getEmailOtp.split("-")[0],
                    name: getEmailOtp.split("-")[1],
                    contact: getEmailOtp.split("-")[2]
                }
            )))
        }
    }, [getEmailOtp, blockIDS.blockId])


    const getMapDsrReq = () => {
        setMapDsrStatus(true)
        const req = {
            actionCustomerMasterRequestVOList: reqArr
        }

        dispatch(dealerCheckList(req, authToken))
        setEditOpenMapDsr(false)
    }
    const CheckListDsrFunc = () => {
        if (mapDsrStatus) {
            if (getCheckListRes.data.status == "success") {
                setMapDsrStatusResArray(getCheckListRes.data)
                setCheckListNotification(true)
                getMultipleMappingListReq()

            }
            if (getCheckListRes.data.status == "failed") {
                setMapDsrStatusResArray(getCheckListRes.data)
                setCheckListNotification(true)
            }
        }
    }

    useEffect(() => {
        CheckListDsrFunc()
    }, [getCheckListRes.data.status])

    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >


                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                autoFocus={true}
                                label="Role"
                                fullWidth={true}
                                name="role"
                                // value={getRole || ""}
                                defaultValue={"Select Role" || getRole}
                            // onChange={handleChange}
                            >
                                <MenuItem value="Select Role" selected="Select Role">
                                    Select Role
                                </MenuItem>
                                <MenuItem value="MERCHANT">MERCHANT</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">

                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Division"
                                fullWidth={true}
                                // name="division"
                                // defaultValue={division || "Select Divison"}
                                // onChange={(e) => onInputChangeMod(e)}
                                name="EditDivision"
                                value={editDivision || ""}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Divison" selected="Select Divison">
                                    Select Division
                                </MenuItem>
                                {/* {setDivisionList.success} */}
                                {setDivisionList.success &&
                                    setDivisionList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>

                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">
                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="District"
                                fullWidth={true}
                                // name="district"
                                // defaultValue={district || "Select District"}
                                // onChange={(e) => onInputChangeMod(e)}
                                name="EditDistrict"
                                value={editDistrict || ""}

                                onChange={handleChange}
                            >
                                <MenuItem value="Select District" selected="Select District">
                                    Select District
                                </MenuItem>
                                {setDistrictList.success &&
                                    setDistrictList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">
                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Thana/Upazilla"
                                fullWidth={true}
                                // name="thana"
                                // defaultValue={thana || "Select Thana/Upazilla"}
                                // onChange={(e) => onInputChangeMod(e)}
                                name="EditThana"
                                value={editThana || ""}

                                onChange={handleChange}
                            >
                                <MenuItem value="Select Thana/Upazilla" selected="Select Thana/Upazilla">
                                    Select Thana/Upazilla
                                </MenuItem>

                                {setThanaList.success &&
                                    setThanaList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">

                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Union/Ward"
                                fullWidth={true}
                                // name="union"
                                // defaultValue={union || "Select Union/Ward"}
                                // onChange={(e) => onInputChangeMod(e)}
                                name="EditUnion"
                                value={editUnion || ""}

                                onChange={handleChange}
                            >
                                <MenuItem value="Select Union/Ward" selected="Select Union/Ward">
                                    Select Union/Ward
                                </MenuItem>
                                {setUnionList.success &&
                                    setUnionList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>


                        <Grid item xs={12} sm={6} md={4} lg={3}>

                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={getMultipleMappingListReq}
                            >
                                Search
                                <SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
                            </CustomButton>

                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />

                ) : getDsrMultiplMappingListStatusArray.length == undefined ||
                    !getDsrMultiplMappingListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 themeBackground"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography
                                        variant="body1"
                                        style={{ fontWeight: "700" }}
                                        className="themeText"
                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="text-nowrap my-3">
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow
                                                style={{ background: "#00b9f5" }}
                                                className="themeBackground"
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >

                                                    Action
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    {" "}
                                                    Agent ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    {" "}
                                                    Agent/Combo name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Division
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    District
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Thana
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Union
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Role
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getDsrMultiplMappingListStatusArray &&
                                                []
                                                    .concat(getDsrMultiplMappingListStatusArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                <input
                                                                    type="checkbox"
                                                                    // key={row.blockId}
                                                                    onChange={(e) => handleChangeCheck(row.customerId, e)}
                                                                />
                                                            </TableCell>
                                                            <TableCell align="center">{row.customerId}</TableCell>
                                                            <TableCell align="center">
                                                                {row.customerName}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.yearly}
                                                            </TableCell>


                                                            <TableCell align="center">{row.daily}</TableCell>
                                                            <TableCell align="center">
                                                                {row.language}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.fname}
                                                            </TableCell>
                                                            <TableCell align="center">{row.userRole}</TableCell>
                                                        </TableRow>
                                                    )

                                                    )}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(getDsrMultiplMappingListStatusArray).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                    <div className="text-center">

                                        <CustomButton
                                            style={{
                                                padding: "8px"
                                            }}
                                            onClick={() => MapDsr()}
                                        >
                                            Map DSR
                                        </CustomButton>
                                    </div>
                                </TableContainer>

                            </Grid>

                        </Card>

                    </div>
                )
                }
            </Layout>

            <div>
                <Dialog open={editOpenMapDsr} onClose={handleClose}>
                    <DialogTitle>Update Dsr Mapping</DialogTitle>
                    <DialogContent>

                        <div style={{ marginTop: "1.5rem" }}>

                            <TextField
                                required
                                select
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Dsr"
                                fullWidth={true}
                                name="getEmailOtp"
                                value={getEmailOtp}
                                onChange={handleChange}
                            >
                                {setDsrList.success && [].concat(setDsrList.data.actionList)
                                    .map((x) => <MenuItem value={x}>{x}</MenuItem>)}
                            </TextField>
                        </div>
                    </DialogContent>

                    <DialogActions>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#00b9f5",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={getMapDsrReq}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>


            </div>

            {getCheckListRes.data.status == "success" && (
                <div>
                    <Dialog open={checkListNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mapDsrStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getCheckListRes.data.status == "failed" && (
                <div>
                    <Dialog open={checkListNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mapDsrStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default DealerMultipleDsrMapping